import TutorialPage from "./tutorial-page"

export const SchoolManagerTutorialPage = () => {


    return (
        <TutorialPage variant='school-manager' />
    )

}